import { Link } from 'react-router-dom';
import { categories } from '@/mocks/site';
import SectionHeading from '@/components/feature/SectionHeading';
import Reveal from '@/components/feature/Reveal';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 border-primary-200',
  secondary: 'bg-secondary-100 text-secondary-800 border-secondary-200',
  accent: 'bg-accent-100 text-accent-800 border-accent-200',
};

export default function CategoriesSection() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-50">
      <SectionHeading
        eyebrow="按玩法找"
        tone="accent"
        title="六种福利玩法，总有一种适合你"
        desc="时间多就做互动任务，朋友多就走邀请路线，不想花时间也能每天签个到攒瓜豆。"
      />

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {categories.map((cat, index) => (
          <Reveal key={cat.id} delay={index * 60}>
            <Link
              to={`/activities?cat=${cat.id}`}
              className="group block h-full bg-background-100 border border-background-200 rounded-2xl p-5 md:p-6 transition-colors hover:border-primary-300 cursor-pointer"
            >
              <div className="flex items-start justify-between">
                <span className={`w-14 h-14 rounded-2xl border flex items-center justify-center text-2xl ${colorMap[cat.color]}`}>
                  <i className={cat.icon}></i>
                </span>
                <span className="text-xs text-foreground-500">{cat.count} 个活动</span>
              </div>
              <h3 className="mt-5 text-lg text-foreground-950 group-hover:text-primary-700 transition-colors">
                {cat.name}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{cat.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm text-primary-600">
                筛选此类活动
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}